import { createSlice } from '@reduxjs/toolkit';
import { getHeatmapHistoryAction, heatmapReportAction, publicCaseReportAction } from '../../actions';
import { adminHeatmapComapreBusienssAction, adminHeatmapKeywordHistoryAction, getAdminHeatmapAction, getAdminHeatmapHistoryAction, getAdminHeatmapHistoryPaginationAction, getHeatmapAction, getHeatmapHistoryPaginationAction, heatmapComapreBusienssAction, heatmapKeywordHistoryAction, pinHeatmapAction } from '../../actions/UserActions/HeatmapAction';

export interface IheatmapHistory {
  _id: string;
  place_id: string;
  keyword: string;
  name: string;
  credits: number;
  added_by: string;
  formatted_address: string;
  type: string;
  timeZone: string;
  nextUpdateTime: string;
  grid_multiplier: number;
  radius: number;
  disabledPins: string[];
  public: boolean;
  position: {
    lat: number;
    lng: number;
  };
  refresh_frequency: string;
  refresh_hour: number;
  report_pending: boolean;
  report_state: string;
  repeat_every: number;
  location: {
    type: string;
    coordinates: [number, number];
  };
  refresh_date: string | null;
  history: {
    report_id: string;
    score: {
      avg: string;
      high: number;
      mid: number;
      low: number;
      marketShare: string;
      not_ranking: number;
    };
    status: string;
    source: string;
    skipReason: string;
    _id: string;
    timestamp: string;
  }[];
  created_at: string;
  __v: number;
  report_id: string;
  score: {
    avg: string;
    high: number;
    mid: number;
    low: number;
    marketShare: string;
    not_ranking: number;
  };
}

export interface IAddHeatmapScan {
  heatmapIds: string[];
  keywords: string[];
}

interface ILocalSeoHeatmapState {
  heatmapHistoryData: IheatmapHistory[];
  hetampHistoryDataLoading: boolean;
  heatmapReportData: any;
  heatmapReportDataLoading: boolean;
  addHeatmapScanData: IAddHeatmapScan | null;
  addHeatmapScanDataLoading: boolean;
  heatmapData: any;
  completedKeyword: any;
  heatmapCompareBusinessData: any;
  heatmapCompareBusinessLoading: boolean;
  isshowheatmapCompareBusiness: boolean
  isshowheatmapCompareBusinessButton: boolean
  pagination: {
    totalPages: number;
    currentPage: number;
    totalItems: number;
    itemsPerPage: number;
  }
}

const initialState: ILocalSeoHeatmapState = {
  heatmapHistoryData: [],
  hetampHistoryDataLoading: false,
  heatmapReportData: [],
  heatmapReportDataLoading: false,
  addHeatmapScanData: null,
  addHeatmapScanDataLoading: false,
  heatmapData: null,
  completedKeyword: [],
  heatmapCompareBusinessData: null,
  heatmapCompareBusinessLoading: false,
  isshowheatmapCompareBusiness: false,
  isshowheatmapCompareBusinessButton: false,

  pagination: {
    totalPages: 0,
    currentPage: 0,
    totalItems: 0,
    itemsPerPage: 0,
  }
};

const hetamapSlice = createSlice({
  name: 'heatmap',
  initialState,
  reducers: {
    setCompetitorBusinessCloseData: state => {
      state.heatmapCompareBusinessData = null;
      state.isshowheatmapCompareBusinessButton = false;
    },
    setShowheatmapCompareBusiness: (state, action) => {
      state.isshowheatmapCompareBusiness = action.payload;
    },
    updateKeywordPinned: (state, action: { payload: { heatmapId: string; pinned: boolean } }) => {
      const { heatmapId, pinned } = action.payload;
      if (Array.isArray(state.completedKeyword)) {
        state.completedKeyword = state.completedKeyword.map((item: any) =>
          (item?.heatmap_id === heatmapId || item?.heatmapId === heatmapId)
            ? { ...item, pinned }
            : item
        );
      }
    }
  },
  extraReducers: builder => {
    builder

      //get heatmap history
      .addCase(getHeatmapHistoryAction.fulfilled, (state, action) => {
        state.hetampHistoryDataLoading = false;
        // state.heatmapHistoryData = action.payload.data;
        state.completedKeyword = action.payload.data?.filter((item: any) => item?.report_state === 'completed' || (item?.report_state === 'failed' && item?.history?.length > 0));
      })

      .addCase(heatmapKeywordHistoryAction.pending, (state, action) => {
        state.hetampHistoryDataLoading = false;
        // state.heatmapHistoryData = action.payload.data;
        state.completedKeyword = [];
        // state.completedKeyword = action.payload.data?.filter((item: any) => item?.report_state === 'completed' || (item?.report_state === 'failed' && item?.history?.length > 0));
      })
      .addCase(heatmapKeywordHistoryAction.fulfilled, (state, action) => {
        state.hetampHistoryDataLoading = false;
        // state.heatmapHistoryData = action.payload.data;
        state.completedKeyword = action.payload.data;
        // state.completedKeyword = action.payload.data?.filter((item: any) => item?.report_state === 'completed' || (item?.report_state === 'failed' && item?.history?.length > 0));
      })

      .addCase(adminHeatmapKeywordHistoryAction.pending, (state, action) => {
        state.hetampHistoryDataLoading = false;
        // state.heatmapHistoryData = action.payload.data;
        state.completedKeyword = [];
        // state.completedKeyword = action.payload.data?.filter((item: any) => item?.report_state === 'completed' || (item?.report_state === 'failed' && item?.history?.length > 0));
      })
      .addCase(adminHeatmapKeywordHistoryAction.fulfilled, (state, action) => {
        state.hetampHistoryDataLoading = false;
        // state.heatmapHistoryData = action.payload.data;
        state.completedKeyword = action.payload.data;
        // state.completedKeyword = action.payload.data?.filter((item: any) => item?.report_state === 'completed' || (item?.report_state === 'failed' && item?.history?.length > 0));
      })

      .addCase(getHeatmapHistoryPaginationAction.fulfilled, (state, action) => {
        state.hetampHistoryDataLoading = false;
        state.heatmapHistoryData = action.payload.data;
        state.pagination = action.payload.pagination;
      })

      .addCase(getAdminHeatmapHistoryAction.fulfilled, (state, action) => {
        state.hetampHistoryDataLoading = false;
        // state.heatmapHistoryData = action.payload.data;
        state.completedKeyword = action.payload.data?.filter((item: any) => item?.report_state === 'completed' || (item?.report_state === 'failed' && item?.history?.length > 0));
      })

      .addCase(getAdminHeatmapHistoryPaginationAction.fulfilled, (state, action) => {
        state.hetampHistoryDataLoading = false;
        state.heatmapHistoryData = action.payload.data;
        state.pagination = action.payload.pagination;
        state.completedKeyword = action.payload.data?.filter((item: any) => item?.report_state === 'completed' || (item?.report_state === 'failed' && item?.history?.length > 0));
      });

    //get heatmap
    builder.addCase(getHeatmapAction.fulfilled, (state, action) => {
      const scanHistoryCompleted = action.payload?.data?.history ? action.payload?.data?.history.filter((itm: any) => itm.status === 'completed') : [];
      state.heatmapData = { ...action.payload.data, scanHistoryCompleted };
    });
    builder.addCase(getHeatmapAction.rejected, state => {
      state.heatmapData = null;
    });

    // get admin heatmap
    // builder.addCase(getAdminHeatmapAction.pending, state => {
    //   state.heatmapData = null;
    // });
    builder.addCase(getAdminHeatmapAction.fulfilled, (state, action) => {
      const scanHistoryCompleted = action.payload?.data?.history ? action.payload?.data?.history.filter((itm: any) => itm.status === 'completed') : [];
      state.heatmapData = { ...action.payload.data, scanHistoryCompleted };
    });
    builder
      .addCase(getAdminHeatmapAction.rejected, state => {
        state.heatmapData = null;
      })

      //report heatmap
      .addCase(heatmapReportAction.pending, (state) => {
        state.heatmapReportDataLoading = true;
      })
      .addCase(heatmapReportAction.fulfilled, (state, action) => {
        state.heatmapReportDataLoading = false;
        state.heatmapReportData = action.payload.data;
      })

      // heatmap compare business
      .addCase(heatmapComapreBusienssAction.pending, state => {
        state.heatmapCompareBusinessLoading = true;
      })
      .addCase(heatmapComapreBusienssAction.fulfilled, (state, action) => {
        state.heatmapCompareBusinessLoading = false;
        state.heatmapCompareBusinessData = action.payload.data;
        state.isshowheatmapCompareBusinessButton = true;
      })
      .addCase(heatmapComapreBusienssAction.rejected, state => {
        state.heatmapCompareBusinessLoading = false;
        state.isshowheatmapCompareBusinessButton = false;
      })

      .addCase(adminHeatmapComapreBusienssAction.pending, state => {
        state.heatmapCompareBusinessLoading = true;
      })
      .addCase(adminHeatmapComapreBusienssAction.fulfilled, (state, action) => {
        state.heatmapCompareBusinessLoading = false;
        state.heatmapCompareBusinessData = action.payload.data;
        state.isshowheatmapCompareBusinessButton = true;
      })
      .addCase(adminHeatmapComapreBusienssAction.rejected, state => {
        state.heatmapCompareBusinessLoading = false;
        state.isshowheatmapCompareBusinessButton = false;
      });

    //public case report 
    builder.addCase(publicCaseReportAction.pending, state => {
      state.heatmapData = null;
    });
    builder.addCase(publicCaseReportAction.fulfilled, (state, action) => {
      const scanHistoryCompleted = action.payload?.data?.history ? action.payload?.data?.history.filter((itm: any) => itm.status === 'completed') : [];
      state.heatmapData = { ...action.payload.data, scanHistoryCompleted };
    });
    builder.addCase(publicCaseReportAction.rejected, state => {
      state.heatmapData = null;
    });

    // pin heatmap
    builder.addCase(pinHeatmapAction.fulfilled, (state, action: any) => {
      const heatmapId = action.meta?.arg?.heatmapId;
      const pinned = action.meta?.arg?.pinned;
      if (heatmapId && Array.isArray(state.completedKeyword)) {
        state.completedKeyword = state.completedKeyword.map((item: any) =>
          (item?.heatmap_id === heatmapId || item?.heatmapId === heatmapId)
            ? { ...item, pinned }
            : item
        );
      }
    });

  }
});

export const { setCompetitorBusinessCloseData, setShowheatmapCompareBusiness, updateKeywordPinned } = hetamapSlice.actions;
export default hetamapSlice.reducer;
